import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminEmailLog from "@/pages/admin/AdminEmailLog";

export const Route = createFileRoute("/admin/email-log")({
  head: () => pageHead("Admin \u2014 Email Log \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminEmailLog,
});
